import AccessControl from '../access-control';
import { ADMINISTRATOR } from '../../../constants/user';

export default {
  'view': () => AccessControl.hasRole(ADMINISTRATOR),
  'view-users': () => AccessControl.hasRole(ADMINISTRATOR),
  'view-reports': () => AccessControl.hasRole(ADMINISTRATOR),
  'view-schools': () => AccessControl.hasRole(ADMINISTRATOR),
  'view-audit': () => AccessControl.hasRole(ADMINISTRATOR)
};


// WEBPACK FOOTER //
// ./src/services/access-control/permissions/admin.js